import firebase from 'firebase/app';
import 'firebase/auth';

function initApp() {
    if (!process.env.VUE_APP_FB_CONFIG) {
        return;
    } else {
        if (!firebase.apps.length) {
            const config = JSON.parse(process.env.VUE_APP_FB_CONFIG);
            firebase.initializeApp(config);
        }
    }
}

initApp();

export async function login(username, password) {
    return firebase.auth().signInWithEmailAndPassword(username, password)
}

export function isLoggedIn() {
    console.log(firebase.auth().currentUser)
    return !!firebase.auth().currentUser
}

export function getAuthToken() {
    return firebase.auth().currentUser.getIdToken(true);
}
